import React, { useState } from "react";
import "../CSS/Footer.css";
import facebook from "../Assests/Images/facebook.png";
import twitter from "../Assests/Images/twitter.png";
import instagram from "../Assests/Images/instagram.png";
import youtube from "../Assests/Images/youtube.png";
import linkedin from "../Assests/Images/linkedin.png";
import { Link } from "react-router-dom";
import India from '../Assests/Images/india.svg'
import FeatureFlag from "../Fileconfigsettings/FeatureFlag"
//Footer section start here
const Footer = () => {
  const SubscribeFeature=FeatureFlag("FeatureFlagOn")
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [thanksMessage, setthanksMessage] = useState("");
  const FhandleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const isValidEmail = (email) => {
    // Regular expression to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleSubscribe = () => {
    if (email.trim() === "") {
      // If email input is empty, display an error message
      setErrorMessage("* Please enter valid email.");
      setthanksMessage(""); // Clear any previous thanks message
    } else if (!isValidEmail(email)) {
      // If the entered email is invalid, display an error message
      setErrorMessage("* Please enter valid email format.");
      setthanksMessage(""); // Clear any previous thanks message
    } else {
      // Simulate a subscription process (you should replace this with a real backend call)
      console.log(`Subscribed with email: ${email}`);
      setSubscribed(true);
      setErrorMessage(""); // Clear any previous error message
      setEmail("");
      setthanksMessage("Thank you for subscribing! 🎉");
    }
  };
  return (
    <div className="FooterWrapper">
      <div className="FootHeadear">
        <div className="FootLogo">
          <h2>BlogWiki</h2>
          <p className="HeadtagLine">Inspired by Information</p>
        </div>
        <div className="Footline"></div>
      </div>
      {SubscribeFeature && <div className="FNewsLetter">
      <input
        className="NewsInput"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={FhandleEmailChange}
          required={true}
        />
        <button className="NewsSubbutton" onClick={handleSubscribe}>
          {subscribed ? "Subscribe" : "Subscribe"}
        </button>
        {errorMessage && <p className="FErrorMessage">{errorMessage}</p>}
        {thanksMessage && <p className="FThanksMessage">{thanksMessage}</p>}
      </div>}
      <div className="CopyrightWrapper">
        <div className="SocailProfileWrapper">
          <p className="SocialPtag">Follow us on</p>
          <a
            className="FooterSocial"
            target="no_blank"
            href="https://www.facebook.com/BlogWiki"
          >
            <img alt="SocialMedia" src={facebook} />
          </a>
          <a
            className="FooterSocial"
            id="twitter"
            target="no_blank"
            href="https://www.twitter.com/BlogWiki_in"
          >
            <img alt="SocialMedia" src={twitter} />
          </a>
          <a
            className="FooterSocial"
            target="no_blank"
            href="https://www.instagram.com/blogwiki.in/"
          >
            <img alt="SocialMedia" src={instagram} />
          </a>
          <a
            className="FooterSocial"
            target="no_blank"
            href="https://www.youtube.com/@BlogWiki_in"
          >
            <img alt="SocialMedia" src={youtube} />
          </a>
          <a
            className="FooterSocial"
            target="no_blank"
            href="https://www.linkedin.com/company/blogwiki/"
          >
            <img alt="SocialMedia" src={linkedin} />
          </a>
        </div>
        <p className="CopyrightTag"> &copy; All rights reserved 2024 | BlogWiki | Made in <abbr title="India"><img className="India" src={India} alt="India" width="30" height="30" /></abbr></p>
      </div>
      <div className="FooterOptionWrapper">
        <div className="OptionLine1 OptionLine">
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper1" to="/">Home</Link>
          </div>
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper2" to="/Gadgets">Gadgets</Link>
          </div>
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper3" to="/Comingsoon">Advertise</Link>
          </div>
        </div>
        <div className="OptionLine2 OptionLine">
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper4" to="/News">News</Link>
          </div>
          <div className="OptioninnerWrapper ">
            <Link className="LinkWrapper LinkWrapper5" to="/Comingsoon">Weather</Link>
          </div>
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper6" to="/PrivacyPolicy">Privacy Policy</Link>
          </div>
        </div>
        <div className="OptionLine OptionLine3">
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper7" to="/Tech">Tech</Link>
          </div>
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper8" to="/About">About</Link>
          </div>
          <div className="OptioninnerWrapper">
            <Link className="LinkWrapper LinkWrapper9" to="/Contact">Contact</Link>
          </div>
        </div>
      </div>
      <div className="BackTopWrapper">
        <div className="BackToBtn" onClick={handleBackToTop}>Back to Top</div>
      </div>
    </div>
  );
};

export default Footer;
